import React from "react";

const Client = () => {
  return <div></div>;
};

export default Client;
